import { toRefs, computed } from 'vue';
import CheckIcon from '../../icons/component-lib.esm28.js';
import Paper from '../paper/component-lib.esm.js';
import VText from '../v-text/component-lib.esm.js';
import { useGroupItem } from '../../compositions/component-lib.esm18.js';

//
var script = {
  name: 'VProduct',
  components: {
    Paper,
    VText,
    CheckIcon
  },
  props: {
    component: {
      type: String,
      default: 'div'
    },
    title: {
      type: String,
      default: null
    },
    image: {
      type: String,
      default: null
    },
    imageAlt: {
      type: String,
      default: null
    },
    price: {
      type: [Number, String, Array],
      default: null
    },
    currencyCode: {
      type: String,
      default: 'USD'
    },
    value: {
      type: [Array, Number, String],
      default: null
    },
    disabled: Boolean,
    noImageSrc: {
      type: String,
      default: 'https://placehold.co/600x400?text=No+Image'
    }
  },
  setup(props, _ref) {
    let {
      emit
    } = _ref;
    const {
      value
    } = toRefs(props);
    const {
      isInGroup,
      onToggle,
      isSelected
    } = useGroupItem(value, 'product-group');
    const rootComponent = computed(() => {
      if (isInGroup) return 'button';
      return props.component;
    });
    const classes = computed(() => ({
      'v-product--selected': isInGroup && isSelected.value,
      'v-product--disabled': props.disabled,
      'v-product--link': rootComponent.value === 'a' || rootComponent.value === 'router-link' || rootComponent.value === 'button'
    }));
    const formattedPrice = computed(() => {
      if (!props.price) return null;
      const prices = Array.isArray(props.price) ? [...new Set(props.price.slice(0, 2))] : [props.price];
      return `${prices.map(price => Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: props.currencyCode,
        trailingZeroDisplay: 'stripIfInteger'
      }).format(price)).join(' - ')} ${props.currencyCode.toUpperCase()}`;
    });
    function handleClick(e) {
      if (props.disabled) return;
      emit('click', e);
      if (isInGroup) onToggle(props.value);
    }
    return {
      classes,
      handleClick,
      isInGroup,
      isSelected,
      formattedPrice,
      rootComponent
    };
  }
};
export { script as default };